import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Car} from '../domain/car';

@Injectable()
export class CarService {

    constructor(private http: Http) {}

    getCarsSmall() {
        return this.http.get('assets/demo/data/cars-small.json')
                    .toPromise()
                    .then(res => <Car[]> res.json().data)
                    .then(data => data);
    }

    getCarsMedium() {
        return this.http.get('assets/demo/data/cars-medium.json')
                    .toPromise()
                    .then(res => <Car[]> res.json().data)
                    .then(data => data);
    }

    getCarsLarge() {
        return this.http.get('assets/demo/data/cars-large.json')
                    .toPromise()
                    .then(res => <Car[]> res.json().data)
                    .then(data => data);
    }
}



// WEBPACK FOOTER //
// ./src/app/demo/service/carservice.ts